
    import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
    import Vue from "vue";
    import Component from "vue-class-component";
    import {
        Certificate,
        CertificatesClient,
        CertificateStatus,
        EndorsementLightViewModel,
        EndorsementsClient,
        EndorsementStatus,
        MedicalCertificateListItem,
        MedicalCertificatesClient, PracticesClient, PracticeType, PracticeViewModel,
        QualificationsClient,
        QualificationViewModel,
        SeafarerActions,
        ValidityStatus

    } from "@/api-client";
    import {Prop} from "vue-property-decorator";
    import userInfo from "@/features/shared/components/UserInfo";
    import FilterCheckbox from "@/components/FilterCheckbox.vue";
    import {factory} from "@/api-client.extensions";
    import {NavigationGuardNext} from "vue-router/types/router";
    import EndorsementsTable from "@/features/personProfile/components/EndorsementsTable.vue";
    import CertificatesTable from "@/features/personProfile/components/CertificatesTable.vue";
    import PracticeTable from "@/features/personProfile/components/PracticeTable.vue";
    import MedicalCertificatesTable from "@/features/personProfile/components/MedicalCertificatesTable.vue";
    import QualificationTable from "@/features/personProfile/components/QualificationTable.vue";

    class Filters {
        valid = true;
        all = false;

        public filterQualifications(qualifications: QualificationViewModel[]): QualificationViewModel[] {
            return qualifications
                .filter(c =>
                    this.all ||
                    this.valid &&
                    c.validity === ValidityStatus.Valid);
        }

        public filterMedicalCertificates(medicalCertificates: MedicalCertificateListItem[]): MedicalCertificateListItem[] {
            return medicalCertificates
                .filter(c =>
                    this.all ||
                    this.valid &&
                    c.status === ValidityStatus.Valid);
        }

        public filterSeafaringPractices(practices: PracticeViewModel[]): PracticeViewModel[] {
            return practices
                .filter(p => p.type == PracticeType.Seafaring)
                .filter(c =>
                    this.all ||
                    this.valid &&
                    c.status === ValidityStatus.Valid);
        }

        public filterShipRepairPractices(practices: PracticeViewModel[]): PracticeViewModel[] {
            return practices
                .filter(p => p.type == PracticeType.ShipRepair)
                .filter(c =>
                    this.all ||
                    this.valid &&
                    c.status === ValidityStatus.Valid);
        }

        public filterCertificates(certificates: Certificate[]): Certificate[] {
            return certificates
                .filter(c =>
                    this.all ||
                    this.valid &&
                    c.status === CertificateStatus.Valid);
        }

        public filterEndorsements(endorsements: EndorsementLightViewModel[]): EndorsementLightViewModel[] {
            return endorsements
                .filter(c =>
                    this.all ||
                    this.valid &&
                    c.status === EndorsementStatus.Valid);
        }

    }


    interface Props {
        qualifications: QualificationViewModel[];
        medicalCertificates: MedicalCertificateListItem[];
        practices: PracticeViewModel[];
        certificates: Certificate[];
        endorsements: EndorsementLightViewModel[];
        seafarerId: string;
        seafarerActions?: SeafarerActions;
    }

    @Component({
        components: {
            QualificationTable,
            MedicalCertificatesTable,
            PracticeTable,
            CertificatesTable,
            EndorsementsTable,
            SectionPageHeading,
            FilterCheckbox,
        },
        beforeRouteEnter(to, from, next: NavigationGuardNext<AllDocuments>) {
            const props = to.meta!.props as Props;
            props.seafarerId = to.params.seafarerId;
            Promise.all([
                new QualificationsClient().list(to.params.seafarerId),
                new MedicalCertificatesClient().list(to.params.seafarerId),
                new PracticesClient().list(to.params.seafarerId),
                new CertificatesClient().certificates(to.params.seafarerId),
                new EndorsementsClient().endorsements(to.params.seafarerId)
            ]).then(values => {
                props.qualifications = values[0];
                props.medicalCertificates = values[1].medicalCertificates;
                props.practices = values[2];
                props.certificates = values[3].certificates;
                props.endorsements = values[4];
                next();
            }).catch(e => next(e))
        }
    })
    export default class AllDocuments extends Vue implements Props {
        @Prop({required:true})
        qualifications!: QualificationViewModel[];
        @Prop({required: true})
        medicalCertificates!: MedicalCertificateListItem[];
        @Prop({required: true})
        practices!: PracticeViewModel[];
        @Prop({required: true})
        certificates!:Certificate[];
        @Prop({ required: true})
        endorsements!: EndorsementLightViewModel[];
        @Prop({required: true})
        seafarerId!: string;

        // Expose PracticeType enum to template
        PracticeType = PracticeType;
        @Prop({required: false, default: () => factory.create(SeafarerActions) })
        seafarerActions!: SeafarerActions;

        userInfo = userInfo;
        filters = new Filters();

        public get filteredQualifications() { return this.filters.filterQualifications(this.qualifications)}
        public get filteredCertificates() { return this.filters.filterCertificates(this.certificates)}
        public get filteredMedicalCertificates() { return this.filters.filterMedicalCertificates(this.medicalCertificates)}
        public get filteredSeafaringPractices() { return this.filters.filterSeafaringPractices(this.practices)}
        public get filteredShipRepairPractices() { return this.filters.filterShipRepairPractices(this.practices)}
        public get filteredEndorsements() { return this.filters.filterEndorsements(this.endorsements)}
    }
